import React, { useEffect, useRef, useState } from 'react'

import './Race.scss'
import { fCurrency, fNumber } from 'helpers/common'
import BetPanel from './BetPanel'
import { Bet } from 'hooks/useDetailedBetResult'
import { useAppContext } from 'context/AppContext'

const Race: React.FC = () => {
  const {
    price,
    betCount,
    setBetCount,
    setBet,
    setLastPrice,
    setFirstPriceAfterBetting,
    customer,
  } = useAppContext()

  const priceRef = useRef(price)

  const [countdown, setCountdown] = useState(3)
  const [isBitPanelInactive, setIsBitPanelInactive] = useState(false)

  useEffect(() => {
    priceRef.current = price
  }, [price])

  const handleClick = (direction: Bet) => {
    if (isBitPanelInactive || betCount === 0) return

    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy')
    }

    setBetCount(betCount - 1)
    setBet(direction)
    setIsBitPanelInactive(true)
    setLastPrice(price)
    setFirstPriceAfterBetting(null)

    let timer = countdown
    const interval = setInterval(() => {
      setCountdown(timer - 1)
      timer -= 1

      if (timer === 0) {
        clearInterval(interval)
        setIsBitPanelInactive(false)
        setCountdown(3)
        setFirstPriceAfterBetting(priceRef.current)
      }
    }, 1000)
  }

  return (
    <div className="Race">
      <div className="Race__background"></div>

      {isBitPanelInactive && <div className="Race__overlay"></div>}

      <div className="Race__points-section">
        <div className="Race__points">
          Points: {fNumber(customer?.points) ?? 0}
        </div>
      </div>

      <div className="Race__bottom-section">
        <div className="Race__price-section">
          <div className="Race__price">
            {price && <p>{fCurrency(price)}</p>}
          </div>
        </div>

        <div className="Race__bet-panel-section">
          <BetPanel
            isInactive={isBitPanelInactive || betCount === 0}
            onClick={handleClick}
            countdown={countdown}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(Race)
